import { render } from "./CustomerAccommodationInquiriesTable.vue?vue&type=template&id=d6405c7e&ts=true"
import script from "./CustomerAccommodationInquiriesTable.vue?vue&type=script&lang=ts"
export * from "./CustomerAccommodationInquiriesTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__